import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import "../styles.css";
import "./accessibility.css";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthContext";
import { appConfig } from "./config";
import { api } from "./lib/api";
import { canonicalProductionHref } from "./lib/productionOrigin";
import { registerWebMcpTools } from "./lib/webmcp";

const canonicalHref = canonicalProductionHref(
  globalThis.location.href,
  appConfig.environment,
);

if (canonicalHref) {
  globalThis.location.replace(canonicalHref);
} else {
  void registerWebMcpTools(document, api.getReport).catch((error: unknown) => {
    console.warn("WebMCP-tools konden niet worden geregistreerd.", error);
  });

  const root = document.getElementById("root");
  if (!root) throw new Error("React root element ontbreekt.");

  createRoot(root).render(
    <StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </StrictMode>,
  );
}
